import {makeItemsListUrl} from '@frontend/helpers'
import {mdiChevronRight} from '@mdi/js'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import type {
    FilteredItemsPageUrlQueryParams,
    ItemsCategoryOrLocationForBreadcrumbs,
} from '../AdsModuleTypes'

interface Props {
    path: ItemsCategoryOrLocationForBreadcrumbs[]
    className?: string
}

// Путь к категории объявления.
export function AdsOrServicesBreadcrumbs(props: Props) {

    const {
        path,
        className,
    } = props

    const {urlQueryData} = useUrlQueryParams<FilteredItemsPageUrlQueryParams>()
    const queryParamsForBreadcrumbs: FilteredItemsPageUrlQueryParams = {}
    if (urlQueryData.location) {
        queryParamsForBreadcrumbs.location = urlQueryData.location
    }
    if (urlQueryData.minPrice) {
        queryParamsForBreadcrumbs.minPrice = urlQueryData.minPrice
    }
    if (urlQueryData.maxPrice) {
        queryParamsForBreadcrumbs.maxPrice = urlQueryData.maxPrice
    }
    if (urlQueryData.keywords) {
        queryParamsForBreadcrumbs.keywords = urlQueryData.keywords
    }

    const items = []
    for (let i = 0; i < path.length; i++) {
        const pathItem: ItemsCategoryOrLocationForBreadcrumbs = path[i]
        items.push(
            <Link
                key={'path-item-' + pathItem.id}
                to={makeItemsListUrl(pathItem, {...pathItem.urlQueryParams, ...queryParamsForBreadcrumbs})}
                className={i === path.length - 1 ? 'text-muted' : 'text-dark'}
            >
                {pathItem.name}
            </Link>
        )
        if (i !== path.length - 1) {
            items.push(
                <Icon
                    key={'separator-' + i}
                    path={mdiChevronRight}
                    color="muted"
                    size={18}
                    className="mx-1"
                />
            )
        }
    }

    return (
        <div
            id="offered-items-breadcrumbs"
            className={clsx(
                'flex-row-center justify-content-start flex-wrap gap-2 lh-sm fs-7',
                className
            )}
        >
            {items}
        </div>
    )
}
